import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getDaysLeft } from '../../utils';
import './DaysLeft.scss';

export const DaysLeft = () => {
  const [futureDate, setFutureDate] = useState(
    // add a year to todays date
    () => new Date(new Date().setFullYear(new Date().getFullYear() + 1))
  );
  const [daysLeft, setDaysLeft] = useState(() => getDaysLeft(futureDate));
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setDaysLeft(() => getDaysLeft(futureDate));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [futureDate]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Days Left Calculator</h2>
        <p className='mb-4'>
          Calculate how many days there are left until a certain date
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select a Date in The Future'
            initDate={futureDate}
            setDate={setFutureDate}
            errorMessage="Selected date should be greater than today's date"
            minDate={new Date()}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p className='mb-0' dangerouslySetInnerHTML={{ __html: daysLeft }} />
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
